module.exports = __webpack_public_path__ + "static/img/4.62c5c9e9.jpg";